const secondaryEmploymentType = [
  { label: 'Angestellten-/ Arbeitertätigkeit', value: 'EMPLOYEE' },
  { label: 'Selbst. Freiberufler/in', value: 'SELF_EMPLOYED_FREELANCER' },
  { label: 'Selbst. Gewerbetreibende/r', value: 'SELF_EMPLOYED_BUSINESSMAN' },
  { label: 'Selbst. Geschäftsführer/in', value: 'SELF_EMPLOYED_CEO' },
  { label: 'Sonstiges', value: 'OTHER' }
]

export default secondaryEmploymentType
